import { render, staticRenderFns } from "./ViewExpired.vue?vue&type=template&id=e5e3b580&scoped=true&"
import script from "./ViewExpired.vue?vue&type=script&lang=js&"
export * from "./ViewExpired.vue?vue&type=script&lang=js&"
import style0 from "./ViewExpired.vue?vue&type=style&index=0&id=e5e3b580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e3b580",
  null
  
)

export default component.exports